export const huaLabels: Record<string, string[]> = {
  bk: ['Very high', 'High', 'Moderate', 'Low', 'Very low'],
  nchv: ['Very high', 'High', 'Moderate', 'Low', 'Very low'],
  hh: ['High', 'Moderate', 'Low', 'Very low'],
  ewb: ['Very high', 'High', 'Moderate', 'Low', 'Very low'],
  nt: ['Very high', 'High', 'Moderate', 'Low', 'Very low'],
  hqi: ['Very Low', 'Low', 'Moderate', 'High', 'Very high'],
  totales: ['Very Low', 'Low', 'Moderate', 'High', 'Very high'],
};

export const huaBundlesLabels: Record<string, string[]> = {
  current: ['Very high', 'High', 'Moderate', 'Low', 'Very low'],
  development: ['Very high', 'High', 'Moderate', 'Low', 'Very low'],
  conservation: ['Very high', 'High', 'Moderate', 'Low', 'Very low'],
  utopia: ['Very high', 'High', 'Moderate', 'Low', 'Very low'],
  repower: ['Very high', 'High', 'Moderate', 'Low', 'Very low'],
  totales: ['Very Low', 'Low', 'Moderate', 'High', 'Very high'],
};
